import './DataManagerSidebar.css'

type ViewKey =
  | 'import'
  | 'audit'
  | 'sales-transactions'
  | 'products'
  | 'sales-pipeline'
  | 'customers'
  | 'accounts'
  | 'gl-transactions'
  | 'suppliers'
  | 'employees'
  | 'competitors'

interface DataManagerSidebarProps {
  activeView: ViewKey
  onNavigate: (view: ViewKey) => void
  recordCounts?: Record<string, number> | null
}

const TOOLS_ITEMS: { key: ViewKey; label: string }[] = [
  { key: 'import', label: 'Import Data' },
  { key: 'audit', label: 'Audit Log' },
]

const DATA_ITEMS: { key: ViewKey; label: string; table: string }[] = [
  { key: 'sales-transactions', label: 'Sales Transactions', table: 'data_sales_transactions' },
  { key: 'products', label: 'Products', table: 'data_products' },
  { key: 'sales-pipeline', label: 'Sales Pipeline', table: 'data_sales_pipeline' },
  { key: 'customers', label: 'Customers', table: 'data_customers' },
  { key: 'accounts', label: 'Chart of Accounts', table: 'data_chart_of_accounts' },
  { key: 'gl-transactions', label: 'GL Transactions', table: 'data_gl_transactions' },
  { key: 'suppliers', label: 'Suppliers', table: 'data_suppliers' },
  { key: 'employees', label: 'Employees', table: 'data_employees' },
  { key: 'competitors', label: 'Competitors', table: 'data_competitors' },
]

function DataManagerSidebar({ activeView, onNavigate, recordCounts }: DataManagerSidebarProps) {
  return (
    <aside className="dm-sidebar">
      <div className="dm-sidebar-section">
        <span className="dm-sidebar-section-label">Tools</span>
        {TOOLS_ITEMS.map((item) => (
          <button
            key={item.key}
            className={`dm-sidebar-item${activeView === item.key ? ' dm-sidebar-item--active' : ''}`}
            onClick={() => onNavigate(item.key)}
          >
            {item.label}
          </button>
        ))}
      </div>
      <div className="dm-sidebar-section">
        <span className="dm-sidebar-section-label">Data</span>
        {DATA_ITEMS.map((item) => {
          const count = recordCounts?.[item.table]
          return (
            <button
              key={item.key}
              className={`dm-sidebar-item${activeView === item.key ? ' dm-sidebar-item--active' : ''}`}
              onClick={() => onNavigate(item.key)}
            >
              <span className="dm-sidebar-item-label">{item.label}</span>
              {recordCounts && (
                <span className={`dm-sidebar-count${count ? '' : ' dm-sidebar-count--empty'}`}>
                  {count ?? 0}
                </span>
              )}
            </button>
          )
        })}
      </div>
    </aside>
  )
}

export default DataManagerSidebar
